<template>
    <v-btn v-if="!isGuest"
           :disabled="isFileUploading(currentFile) || !canArchiveAsset || blockLoading"
           @click="moveToArchive(currentFile)"
           :content="currentFile.type == 'image' ? 'Archive media asset' : 'Archive Candidate'"
           v-tippy
    >
        <v-icon class="material-icons">mdi-restore</v-icon>
    </v-btn>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapGetters, mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image', 'currentFile']),
        ...mapState("UI", ['startTips', 'showAddMatchTooltip']),
        ...mapGetters('User', ['isGuest']),
    },
    methods: {
        // TODO move to store
        isFileUploading(file) {
            if (file.status !== "uploaded") return true;
            else return false;
        },

        async moveToArchive(file) {
            await this.$store.dispatch("Projects/selectBin", file.bin_id);
            let selectedFiles = [file];

            vm.$store.dispatch("Loader/showProgressBar", "indeterminate");

            if (selectedFiles[0].type == "image") {
                if (!UI.selectNextImage(selectedFiles[0].id)) {
                    if (!UI.selectPreviousImage(selectedFiles[0].id)) {
                        this.$store.dispatch("Projects/switchProject");
                    }
                }
            }

            for await (const selectedFile of selectedFiles) {
                let isUploading = await window.uploadImagesStore.getItem(selectedFile.id);
                if (isUploading) {
                    alert("Image can't be moved while uploading to server. Try again later");
                    return;
                }
                await window.imagesStore.removeItem(selectedFile.id);

                window
                    .$(`#project-navigator-container .file[file_id="${selectedFile.id}"`)
                    .closest(".v-treeview-node__root")
                    .remove();
            }

            await this.$store.dispatch("Projects/moveTo", {
                file_id: selectedFiles[0].id,
                action: "Archive",
                file_ids: selectedFiles.map(e => e.id),
            });

            await this.$store.dispatch("Projects/refreshProjectTree");
            vm.$store.dispatch("Loader/showProgressBar", false);
        },
    }
}
</script>